// FullscreenToggle.js
export class FullscreenToggle {
    constructor(containerSelector = ".container-column", buttonSelector = ".full-screen-button") {
        this.containerSelector = containerSelector;
        this.buttonSelector = buttonSelector;
        this.activeContainer = null;
    }

    init() {
        // Event delegation: listen on document for any button click
        document.addEventListener("click", (e) => {
            const button = e.target.closest(this.buttonSelector);
            if (!button) return;

            const container = button.closest(this.containerSelector);
            if (!container) return;

            const isFullScreen = container.classList.contains("fullscreen");
            isFullScreen ? this.exitFullscreen() : this.enterFullscreen(container, button);
        });

        // ESC key closes fullscreen
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.activeContainer) {
                this.exitFullscreen();
            }
        });
    }

    enterFullscreen(container, button) {
        const allContainers = document.querySelectorAll(this.containerSelector);
        this.activeContainer = container;

        allContainers.forEach(widget => {
            // track only widgets currently visible
            widget.dataset.wasVisible = widget.style.display !== "none" ? "true" : "false";

            if (widget !== container && widget.dataset.wasVisible === "true") {
                widget.style.display = "none";
            } else if (widget === container) {
                widget.style.display = "";
                widget.classList.add("fullscreen");
            }
        });

        document.body.style.overflow = "hidden"; // prevent scroll
        button.querySelector("span.iconify")?.setAttribute("data-icon", "akar-icons:shrink");

        setTimeout(() => this.animateChartResize(container), 300);
    }

    exitFullscreen() {
        if (!this.activeContainer) return;

        const allContainers = document.querySelectorAll(this.containerSelector);

        allContainers.forEach(widget => {
            widget.classList.remove("fullscreen");

            // Only restore widgets that were visible originally
            if (widget.dataset.wasVisible === "true") {
                widget.style.display = "";
            }

            delete widget.dataset.wasVisible;
        });

        // Restore icon
        const button = this.activeContainer.querySelector(this.buttonSelector);
        button?.querySelector("span.iconify")?.setAttribute("data-icon", "akar-icons:enlarge");

        document.body.style.overflow = "";
        this.activeContainer = null;

        setTimeout(() => this.animateChartResize(document), 300);
    }

    animateChartResize(scope = document) {
        window.dispatchEvent(new Event("resize"));
    }
}
